import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import {
  Button, Card, CardContent, Grid,
  Fab, InputAdornment, InputBase,
  IconButton
} from '@material-ui/core'

import SearchIcon from '@material-ui/icons/Search'
import ClearIcon from '@material-ui/icons/Clear'

import { Toast as NotificationToast, ConfirmToast } from '../../tools'

import AUPnew from './AUPnew'
import AUPedit from './AUPedit'
import AUPview from './AUPview'

import 'quill/dist/quill.snow.css'
import { getAupList, deleteAup } from '../../../../redux/actions'

import { makeStyles, fade } from '@material-ui/core/styles'

const theme = 'snow'

const modules = {
  toolbar: [
    ['bold', 'italic', 'underline', 'strike'],
    [{ align: [] }],

    [{ list: 'ordered' }, { list: 'bullet' }],
    [{ indent: '-1' }, { indent: '+1' }],

    [{ size: ['small', false, 'large', 'huge'] }],
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    ['link'],
    [{ color: [] }, { background: [] }],

    ['clean']
  ]
}

const placeholder = 'Acceptable use policy...'

const formats = [
  'bold', 'italic', 'underline', 'strike',
  'align', 'list', 'indent',
  'size', 'header', 'link',
  'color', 'background',
  'clean'
]

const useStyles = makeStyles(theme => ({
  formControl: {
    // margin: theme.spacing(1),
    minWidth: 350,
    maxWidth: 350,
    marginTop: '2rem'
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  chip: {
    margin: 2
  },
  noLabel: {
    marginTop: theme.spacing(3)
  },
  cssUnderline: {
    '&:after': {
      borderBottomColor: '#A4D164'
    }
  },
  cssLabel: {
    '&$cssFocused': {
      color: '#A4D164'
    }
  },
  cssFocused: {},
  aupCard: {
    width: '98%'
  },
  greenBtn: {
    color: '#fff',
    backgroundColor: '#A4D164',
    '&:hover': {
      backgroundColor: '#8AB651'
    }
  },
  deleteBtn: {
    color: '#fff',
    backgroundColor: '#e57373',
    '&:hover': {
      backgroundColor: '#d05b5b'
    }
  },
  editBtn: {
    backgroundColor: '#3984f7',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#0651C4'
    }
  },
  search: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade('#868787', 0.15),
    '&:hover': {
      backgroundColor: fade('#868787', 0.25)
    },
    width: '75%',
    marginLeft: 'auto',
    marginBottom: '.5rem'
  },
  searchIcon: {
    padding: theme.spacing(0, 1),
    height: '100%',
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    pointerEvents: 'none'
  },
  inputInput: {
    padding: theme.spacing(2, 1, 2, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(5)}px)`,
    transition: theme.transitions.create('width'),
    width: '100%'
  },
  searchBtn: {
    color: '#fff',
    backgroundColor: '#3984f7',
    '&:hover': {
      backgroundColor: '#0651C4'
    }
  },
  saveBtn: {
    color: '#fff',
    backgroundColor: '#3984f7',
    '&:hover': {
      backgroundColor: '#0651C4'
    }
  },
  aupContainer: {
    maxHeight: '37em',
    width: '100%',
    padding: theme.spacing(2, 0),
    marginLeft: 'auto',
    marginRight: 'auto'
    // overflowX: 'hidden',
    // overflowY: 'scroll'
  }
}))

const useTextStyles = makeStyles((theme) => ({
  root: {
    overflow: 'hidden',
    backgroundColor: '#fff',
    width: '100%',
    '&:hover': {
      backgroundColor: '#f5f5f5'
    },
    '&$focused': {
      backgroundColor: '#f5f5f5 !important'
    }
  },
  focused: {}
}))

/**
 * Returns AUP forms
 */
const AUPlist = () => {
  const [aupFormSwap, setAupFormSwap] = useState('list')

  const [aupName, setAupName] = useState('')
  const [aupHtml, setAupHtml] = useState([])
  const [aupID, setAupID] = useState('')

  const classes = useStyles()
  const textClasses = useTextStyles()

  const aupsList = useSelector(state => state.aups.aupList)

  const defaultAUP = useSelector(state => state.orgSettingsSettings.general.defaultAUP)

  useEffect(() => {
    // moves default aup to the begining of the list
    const newAups = [
      aupsList.find(aupsList => aupsList.aupID === defaultAUP),
      ...aupsList.filter(aupsList => aupsList.aupID !== defaultAUP)
    ]
    setNewAupList(newAups)
  }, [aupsList, aupFormSwap, defaultAUP])

  const [newAupsList, setNewAupList] = useState([])

  const dispatch = useDispatch()

  const [searchVal, setSearchVal] = useState('')

  function swapForms () {
    return (
      <div>
        {(() => {
          switch (aupFormSwap) {
            case 'list':
              return renderAupList()
            case 'new':
              return (
                <AUPnew
                  theme={theme}
                  modules={modules}
                  formats={formats}
                  placeholder={placeholder}
                  onBackTrack={handleBackTrack}
                  classes={classes}
                  textClasses={textClasses}
                />
              )
            case 'edit':
              return (
                <AUPedit
                  aupID={aupID}
                  aupName={aupName}
                  aupHtml={aupHtml}
                  theme={theme}
                  modules={modules}
                  formats={formats}
                  onBackTrack={handleBackTrack}
                  classes={classes}
                  textClasses={textClasses}
                />
              )
            case 'view':
              return (
                <AUPview
                  aupName={aupName}
                  aupHtml={aupHtml}
                  theme={theme}
                  formats={formats}
                  placeholder={placeholder}
                  onBackTrack={handleBackTrack}
                  classes={classes}
                  textClasses={textClasses}
                />
              )
            default:
              return null
          }
        })()}
      </div>
    )
  }

  function setData (aup) {
    setAupName(aup.aupName)
    setAupHtml(aup.aupHTML)
    setAupID(aup.aupID)
  }

  const handleBackTrack = () => {
    setAupName('')
    setAupHtml([])
    setAupID('')
    setAupFormSwap('list')
  }

  const handleDeleteAup = async (aupID) => {
    const deleteOption = await ConfirmToast({ msg: 'Are you sure you want to delete this AUP?' })
    if (deleteOption === true) {
      dispatch(deleteAup(aupID, fireDeleteSuccess, fireDeleteFailure))
      dispatch(getAupList())
      handleBackTrack()
    }
  }

  const fireDeleteSuccess = () => {
    NotificationToast(false, 'Successfully deleted AUP!')
    dispatch(getAupList())
  }

  const fireDeleteFailure = () => {
    NotificationToast(true, 'Failed to AUP.')
  }

  function RenderButtons (aup) {
    if (aup.aupID === defaultAUP) {
      return (
        <>
          <Button
            className={`${classes.greenBtn} mt-3 mr-4`}
            onClick={(e) => { e.preventDefault(); setAupFormSwap('view'); setData(aup) }}
            variant='contained'
          >
            <span className='font-weight-bold'>View</span>
          </Button>
        </>
      )
    } else {
      return (
        <>
          <Button
            className={`${classes.greenBtn} mt-3 mr-4`}
            onClick={(e) => { e.preventDefault(); setAupFormSwap('view'); setData(aup) }}
            variant='contained'
          >
            <span className='font-weight-bold'>View</span>
          </Button>

          <Button
            className={`${classes.editBtn} mt-3 mr-4`}
            onClick={(e) => { e.preventDefault(); setAupFormSwap('edit'); setData(aup) }}
            variant='contained'
          >
            <span className='font-weight-bold'>Edit</span>
          </Button>

          <Button
            className={`${classes.deleteBtn} mt-3 mr-4`}
            onClick={(e) => { e.preventDefault(); handleDeleteAup(aup.aupID) }}
            variant='contained'
          >
            <span className='font-weight-bold'>Delete</span>
          </Button>
        </>
      )
    }
  }

  function renderAupList () {
    return (
      <>
        <Grid item container direction='row'>
          <Grid item container direction='column' sm={12}>
            <Grid item container direction='row'>
              <Grid item container direction='column' sm={7}>
                <h2 className='mr-3 mb-4'>Policy Manager</h2>
              </Grid>
              <Grid item container direction='column' sm={5} className='mt-2'>
                <Grid item container direction='row' className='justify-content-end mr-1'>
                  <div className={classes.search}>
                    <div className={classes.searchIcon}>
                      <Fab
                        className={classes.searchBtn}
                        size='small'
                      >
                        <SearchIcon />
                      </Fab>
                    </div>
                    <InputBase
                      placeholder='Policy Name'
                      classes={{
                        root: classes.inputRoot,
                        input: classes.inputInput
                      }}
                      inputProps={{ 'aria-label': 'search' }}
                      onChange={(e) => {
                        setSearchVal(e.target.value)
                      }}
                      value={searchVal}
                      endAdornment={
                        searchVal !== ''
                          ? (
                            <InputAdornment position='start'>
                              <IconButton onClick={() => setSearchVal('')}>
                                <ClearIcon />
                              </IconButton>
                            </InputAdornment>
                          ) : (<></>)
                      }
                    />
                  </div>
                </Grid>
                <Grid item container direction='row' className='justify-content-end mr-1 my-3'>
                  <Button
                    className={`${classes.greenBtn} ml-3`}
                    onClick={(e) => { e.preventDefault(); setAupFormSwap('new') }}
                    variant='contained'
                  >
                    <span className='font-weight-bold'>Create A New AUP</span>
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid item container direction='row' style={{ overflowY: newAupsList.length > 5 ? 'scroll' : 'none' }} className={classes.aupContainer}>
            <Grid item container direction='column'>
              {newAupsList.filter((aup) => {
                return aup.aupName.toLowerCase().includes(searchVal.toLowerCase())
              }).map((aup, i) => (
                <Grid item container direction='row' key={`aup-${i}`} className='mx-auto my-2 w-98' justify='center'>
                  <Card raised className={classes.aupCard} value={aup}>
                    <CardContent>
                      <Grid item container direction='row' className='align-items-center'>
                        <Grid item container direction='column' sm={7}>
                          <h5
                            style={{ fontWeight: 'bold', color: '#007bff', marginBottom: '0' }}
                          >
                            {aup.aupName}
                            <span
                              style={{ backgroundColor: '#b1d57e' }}
                              className='badge badge-primary ml-3 unselectable'
                            >
                              {aup.aupID === defaultAUP ? 'Default AUP' : ''}
                            </span>
                          </h5>
                        </Grid>
                        <Grid item container direction='column' sm={5}>
                          <Grid item container direction='row' className='justify-content-end'>
                            {RenderButtons(aup)}
                          </Grid>
                        </Grid>
                      </Grid>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>
      </>
    )
  }

  return (
    swapForms()
  )
}

export default AUPlist
